import { BlogCommonAuthor } from '@doltech/ui/lib/figma/Blog/BlogCommonAuthor';
import { dolDinhLucAuthor } from '@doltech/ui/lib/figma/Blog/dolDinhLucAuthor.data';
import { BlogSocialButton } from '@doltech/ui/lib/figma/Layout/Landing/SocialButton/BlogSocialButton';
import * as React from 'react';

export const AuthorPreview = ({ lastModifiedAt, length, seoData }) => {
  return (
    <BlogCommonAuthor
      className="author-preview"
      blogLength={length}
      socials={
        seoData && (
          <BlogSocialButton
            seoData={seoData}
            align="horizontal"
            actions={['copy-link', 'facebook', 'clap']}
          />
        )
      }
      publishedDate={lastModifiedAt}
      author={dolDinhLucAuthor}
      readTimeInMinutes={undefined}
    />
  );
};
